// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-device-container {
  padding: 30px 14%;
  border-radius: 10px;
  background-color: #f9f9f9;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/addDevice/addDevice.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".add-device-container {\n  padding: 30px 14%;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
